import { Component, Input, OnInit } from "@angular/core";
import { CommandAsync, ICommand } from "@nahuelmorata/ngx-command";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { PaisDTO } from "@DTOS";
import { PaisesAcciones, State } from "@shared/states";
import { Condicion } from "../../clases/Condicion";
import { ModalService } from "@shared/services";


@Component({
    selector: "app-condicion-su-pais-es",
    templateUrl: "./condicion-su-pais-es.component.html",
    styleUrls: ["./condicion-su-pais-es.component.scss"]
})
export class CondicionSuPaisEsComponent implements OnInit {
    @Select((state: State) => state.paises.paises) public paises: Observable<PaisDTO[]>;
    @Input() public condicion: Condicion;

    public borrarOperandoCmd: ICommand = new CommandAsync(() => this.borrar());

    constructor(private modalService: ModalService, private store: Store) {}

    ngOnInit() {
        this.store.dispatch(new PaisesAcciones.Obtener());
    }

    private async borrar() {
        const seguroBorrar = await this.modalService.openModalDecision(
            "Esta seguro que quiere eliminar el operando?", { centered: true }
        );

        if (!seguroBorrar) {
            return;
        }

        this.condicion.borrar();
    }
}
